<template>
  <div class="fixed inset-0 z-40 flex h-full w-full items-center justify-center">
    <!-- animation + message -->
    <div class="relative z-40 w-full max-w-[720px]">
      <div ref="container" />
    </div>

    <!-- backdrop overlay -->
    <div class="fixed inset-0 z-30 h-full w-full backdrop-blur-[2px] bg-[rgba(20,17,11,0.8)]" />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import lottie from "lottie-web";

const props = defineProps({
  animationData: { type: Object, required: true },
  loop: { type: Boolean, default: false },
  autoplay: { type: Boolean, default: true },
  speed: { type: Number, default: 0.7 },
});

const container = ref(null);
let anim = null;

onMounted(() => {
  anim = lottie.loadAnimation({
    container: container.value,
    renderer: "svg",
    loop: props.loop,
    autoplay: props.autoplay,
    animationData: props.animationData,
  });
  anim.setSpeed(props.speed);
  document.body.style.overflow = "hidden";
});

watch(
  () => props.speed,
  (val) => anim?.setSpeed(val)
);

onBeforeUnmount(() => {
  anim?.destroy();
  anim = null;
  document.body.style.overflow = "auto";
});

defineExpose({
  play: () => anim?.play(),
  pause: () => anim?.pause(),
  stop: () => anim?.stop(),
});
</script>
